export default function zeroLeft(number) {
  if (typeof number !== "number") return number;
  if (number > 9) return `${number}`;
  return `0${number}`;
}
